import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.classlist = this.data.get('classes').split(',');
  }

  toggle() {
    this.classlist.forEach((className) => this.element.classList.toggle(className));
  }
}
